<template>
  <div class="transparent-mask" v-show="isShow" @keydown.stop @mousedown.stop>
    <div class="cancle-play" :style="{width: Window_Size.width + 'px', height: Window_Size.height + 'px'}" @click.self="canclePlay"></div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  data () {
    return {
      ANALYSIS: {
        whirl : {category:'rotate_animation_pane', action:'click_blank_back_preview', label:'旋转动画_空白_返回预览面板'},
        shake : {category:'shake_animation_pane', action:'click_blank_back_preview', label:'抖动动画_空白_返回预览面板'},
        pathAnim : {category:'path_animation_pane', action:'click_blank_back_preview', label:'路径动画_空白_返回预览面板'},
      },
      isShow: false,
      spriteBox: null,
      previewSource: ''
    }
  },
  computed: {
    ...mapGetters([
      'Window_Size',
      'TOOL'
    ])
  },
  mounted() {
    this.$bus.on('preview_callback', (data) => {
      if(data.type === 'play') {
        this.isShow = true;
        this.spriteBox = data.spriteBox;
        this.previewSource = data.source;
      } else {
        this.isShow = false;
        this.spriteBox = null;
      }
    })
    this.$bus.on('timeline_play_scenes', data => {
      if(this.isShow && !data.isPlay) {
        this.isShow = false;
        this.spriteBox = null;
      }
    })
  },
  methods: {
    canclePlay() {
      this.isShow = false;
      this.$bus.emit('timeline_play_stop', {isPlay: false});
      this.TOOL.selectSprite([this.spriteBox]);
      this.$bus.emit('FeaturesPop_vue', {
        type: 1,
        name: 'effectSetting',
        sprite: this.spriteBox,
        contentType: this.previewSource
      });
      this.$analysis(this.ANALYSIS[this.previewSource])
    }
  }
}
</script>
<style lang="scss" scoped>
.transparent-mask {
  position: relative;
  z-index: 30;
}
.cancle-play {
  position: fixed;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/TransparentMask.vue